import store from './store';
import router from './router/index';

const  whitelist = []

router.beforeEach((to,from,next) => {
  if(store.getters.token){
    next()
  } else {
    // if(whitelist.indexOf(to.path)!==-1){
    //   next()
    // }else {

    // }
    next()
  }
})

